/* === Arquivo: src/components/Header/Header.js === */
/* (Versão correta com o import do CSS certo) */

import React from 'react';

// AQUI ESTÁ A CORREÇÃO: Deve importar './Header.css'
import './Header.css'; 

// Importa a logo (assumindo que 'logo192.png' está nesta pasta)
import logo from './logo192.png'; 

function Header() {
  return (
    <header className="app-header">
      <div className="header-content">
        <img src={logo} alt="Logo Aetheries" className="header-logo" />
      </div>
    </header>
  );
}

export default Header;